/* eslint-disable react/no-danger */
// React
import React from "react";

// Libraries
import PropTypes from "prop-types";
import DOMPurify from "dompurify";

// Components
import Text from "@Components/Text";

// Styles
import styles from "./styles.module.css";

const EmailContent = ({ item }) => {
	const clean = DOMPurify.sanitize(item.html, { USE_PROFILES: { html: true } });
	return (
		<div className={styles.content}>
			<Text className={styles.subject}>{item.text}</Text>
			<div dangerouslySetInnerHTML={{ __html: clean }} />
		</div>
	);
};

EmailContent.propTypes = {
	item: PropTypes.object,
};

export default EmailContent;
